import { qwanyxCollection } from 'qwanyx'

/**
 * Fetches a single qwantum value by document _id and qwantum key
 * 
 * @param {string|ObjectId} _id - The unique _id of the document
 * @param {string} qwantumId - The key of the qwantum value to retrieve
 * @returns {Promise<any|null>} - The qwantum value if found, null otherwise
 */
export async function getQwantum(_id, qwantumId) {
    try {
        console.log("getQwantum called with:", { _id, qwantumId });
        
        const collection = qwanyxCollection();
        console.log("Collection:", collection);

        const result = await collection.findOne(
            { _id }, 
            { projection: { [qwantumId]: 1 } }
        );
        
        console.log("Database result:", result);
        
        const qwantumValue = result ? result[qwantumId] : null;
        console.log("Returning qwantum value:", qwantumValue);
        
        return qwantumValue;
    } catch (error) {
        console.error("Error fetching qwantum:", error);
        throw error;
    }
}